const nodeEnv = require('node-env.js')

export const environment = {
  production: false,
  API_BASE_URL: 'https://dev-backend.journeyfinda.com/api/v1/',
  ENCRIPTION_PRIVATE_KEY: nodeEnv.ENCRIPTION_PRIVATE_KEY,
  SOCKET_URL: 'https://dev-backend.journeyfinda.com'

};